import { render } from "./AntModal.vue?vue&type=template&id=1b030b9e"
import script from "./AntModal.vue?vue&type=script&lang=js"
export * from "./AntModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__